import {GradientBorderButton} from 'Components/GradientBorderButton';

//const Caleb = 'https://calendly.com/calebouellette/15min';
const Robert = 'https://calendly.com/rnowell/15min';

export const Waitlist = () => {
    return (
        <div className="flex w-96 flex-col items-center gap-5 rounded-lg bg-white p-10 shadow-xl">
            <img src="https://file.rendit.io/n/fDgXqtQaidcPvq2UJpSQ.svg" alt="Frame1" className="h-10 w-10" />
            <h1 className="text-center text-xl font-bold">Schedule a call to get access to Rendition Vision.</h1>
            <p className="text-center text-sm text-gray-500">
                Rendition vision offers greatly improved code. We'll walk you through how to use it and give you a free
                trial!
            </p>

            <GradientBorderButton onClick={() => window.open(Robert)}>
                <span className="relative">Schedule Now</span>
            </GradientBorderButton>
        </div>
    );
};
